import type { OfferKind } from "@root/utils/enums/offer";
import { useCallback } from "react";
import { axios } from "./axios";

export const useArchiveOffer = () => {
  const [state, execute, cancel] = axios<void, void, unknown>(
    {
      method: "put",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (kind: OfferKind, offerId: string) => {
      return execute({
        url: `/v2/offers/${kind}/${offerId}/disable`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
